import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDisplaySlash,
  faGearComplexCode,
} from "@fortawesome/pro-solid-svg-icons";
import {
  PortalStatusType,
  StatusBannerWrapper,
  StatusBannerHeader,
  StatusBannerIconWrapper,
  StatusBannerTitle,
  StatusBannerBody,
  StatusBannerMessage,
  StatusBannerLink,
} from "./PortalStatusBanner.styles";

export interface PortalStatusFlag {
  enabled: boolean;
  status: PortalStatusType;
  title: string;
  message: string;
  statusPageUrl?: string | null;
}

interface PortalStatusBannerProps {
  status: PortalStatusType;
  title: string;
  message: string;
  statusPageUrl?: string | null;
}

const PortalDownIcon: React.FC = () => (
  <FontAwesomeIcon
    icon={faDisplaySlash}
    style={{ width: "20px", height: "20px", fontSize: "20px" }}
    aria-hidden="true"
  />
);

const MaintenanceIcon: React.FC = () => (
  <FontAwesomeIcon
    icon={faGearComplexCode}
    style={{ width: "20px", height: "20px", fontSize: "20px" }}
    aria-hidden="true"
  />
);

const getStatusIcon = (status: PortalStatusType): React.ReactElement => {
  switch (status) {
    case "down":
      return <PortalDownIcon />;
    case "maintenance":
    case "maintenanceUpcoming":
      return <MaintenanceIcon />;
    default:
      return <PortalDownIcon />;
  }
};

export const PortalStatusBanner: React.FC<PortalStatusBannerProps> = ({
  status,
  title,
  message,
  statusPageUrl,
}) => (
  <StatusBannerWrapper status={status}>
    <StatusBannerHeader>
      <StatusBannerIconWrapper status={status}>
        {getStatusIcon(status)}
      </StatusBannerIconWrapper>
      <StatusBannerTitle status={status}>{title}</StatusBannerTitle>
    </StatusBannerHeader>
    <StatusBannerBody>
      <StatusBannerMessage status={status}>
        {message}
        {statusPageUrl && (
          <>
            {" "}
            <StatusBannerLink
              status={status}
              href={statusPageUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Status Page
            </StatusBannerLink>
          </>
        )}
      </StatusBannerMessage>
    </StatusBannerBody>
  </StatusBannerWrapper>
);
